// 숫자·날짜 포맷과 CSV 읽기 같은 화면 공용 유틸.
//
// 예전에는 여기 api 헬퍼가 하나 더 있었다. /fin 을 앞에 붙여 Express(4100)로 보내는
// 것이었는데, 원가관리를 granter 로 옮기면서 부르는 화면이 하나도 남지 않았다.
// 같은 경로를 어느 헬퍼로 부르느냐에 따라 백엔드가 갈리는 구조라 헷갈리기만 해서 걷어냈다.
// 서버로 가는 길은 portalApi.js 하나다.

// digits: 최대 소수 자리. minDigits를 주면 그만큼 0을 채워 자릿수를 고정한다
// (외화 금액은 251,459.40처럼 두 자리로 맞춰 보는 편이 읽기 쉽다).
export const fmt = (v, digits = 0, minDigits = 0) =>
  v === null || v === undefined || v === '' || Number.isNaN(Number(v))
    ? '-'
    : Number(v).toLocaleString('ko-KR', { maximumFractionDigits: digits, minimumFractionDigits: minDigits })

export const fmtWon = (v) => (v === null || v === undefined ? '-' : `${fmt(v)}원`)

// 외화처럼 소수 자릿수를 고정해서 보여줘야 할 때 (12500.5 → 12,500.50). digits=0이면 fmt와 같다.
export const fmtFixed = (v, digits = 2) =>
  v === null || v === undefined || v === '' || Number.isNaN(Number(v))
    ? '-'
    : Number(v).toLocaleString('ko-KR', { minimumFractionDigits: digits, maximumFractionDigits: digits })

// 백엔드는 UTC ISO(+00:00) 타임스탬프를 저장한다 (datetime.now(timezone.utc)) — 화면엔 KST로 변환해서 보여준다.
export const fmtDateTime = (iso) => {
  if (!iso) return ''
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return String(iso).slice(0, 16).replace('T', ' ')
  return d.toLocaleString('sv-SE', { timeZone: 'Asia/Seoul', hour12: false }).slice(0, 16)
}

// 간단한 CSV 파서 (따옴표, BOM 처리)
export function parseCsv(text) {
  const rows = []
  let row = [], cell = '', inQ = false
  const s = text.replace(/^﻿/, '')
  for (let i = 0; i < s.length; i++) {
    const c = s[i]
    if (inQ) {
      if (c === '"') {
        if (s[i + 1] === '"') { cell += '"'; i++ } else inQ = false
      } else cell += c
    } else if (c === '"') inQ = true
    else if (c === ',') { row.push(cell); cell = '' }
    else if (c === '\n' || c === '\r') {
      if (c === '\r' && s[i + 1] === '\n') i++
      row.push(cell); cell = ''
      if (row.some((x) => x !== '')) rows.push(row)
      row = []
    } else cell += c
  }
  row.push(cell)
  if (row.some((x) => x !== '')) rows.push(row)
  if (!rows.length) return []
  const header = rows[0].map((h) => h.trim())
  return rows.slice(1).map((r) => Object.fromEntries(header.map((h, i) => [h, (r[i] ?? '').trim()])))
}

export function pickCsvFile(onRows) {
  const input = document.createElement('input')
  input.type = 'file'
  input.accept = '.csv,text/csv'
  input.onchange = () => {
    const f = input.files?.[0]
    if (!f) return
    const reader = new FileReader()
    reader.onload = () => onRows(parseCsv(String(reader.result)))
    reader.readAsText(f, 'utf-8')
  }
  input.click()
}
